import * as React from 'react';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import ComanderBar from "../ComanderBar/ComanderBar";
import { MyContext } from '../../../context';
import { Checkbox } from '@fluentui/react';
import SettingsColumnsStorages from './SettingsColumnsStorages';
import { queryGetLoggedUserData } from '../../../queries/querySettings'
import AlertBar from '../../CustomComponents/AlertBar';

const controlStyles = {
    root: {
        margin: '0 30px 20px 0',
        maxWidth: '300px'
    },
    settingsButton: {
        position: "absolute",
        top: "37px",
        zIndex: "999",
        right: "5px"
    }
};
const headerStyle: Partial<IDetailsColumnStyles> = {
    cellTitle: {
        marginLeft: '45px'
    }
}
export interface IDocument {
    name: String;
    group: String;

}

export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    items: IDocument[];
    selectionDetails: string;
    isModalSelection: boolean;
    isCompactMode: boolean;
}
export default class StoragesList extends React.Component<{}, IDetailsListDocumentsExampleState> {
    _selection: Selection;
    _allItems: IDocument[];

    defaultSettingsColumns = ["displayName", "visibleForAssignment", "isActive", "storageLocation", "storageAccountName", "storageUsed", "keyVaultUrl", "isAsymmetric", "keyVaultName", "archiving"];
    constructor(props) {
        super(props);
        let columnsDefaultSetting: IColumn[] = [
            {
                key: 'defaultStorage',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "defaultStorage")}</>)}</MyContext.Consumer>,
                fieldName: 'defaultStorage',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                onRender: (item) => (
                    <div style={{ marginLeft: '55px' }}>{item.defaultStorage}</div>
                ),
                styles: headerStyle

            },

        ];

        let defaultStorageItem = this.getDefaultStorage();

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails(),
                    warningMessage: ""

                });
            }
        });

        this.state = {
            items: this._allItems,
            columns: [],
            allColumns: [],
            settingsColumns: [],
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: false,
            isCompactMode: true,
            filter: "",
            defaultStorageItem: defaultStorageItem,
            columnsDefaultSetting: columnsDefaultSetting,
            warningMessage: ""
            ,
            displayHistorical: false
        };
        this.setDisplayHistorical = this.setDisplayHistorical.bind(this);
    }

    async componentDidMount() {
        //get column settings from db
        let auth = this.props.authorization
        let result = await this.props.apol
            .query({
                query: queryGetLoggedUserData,
                variables: { auth }
            })
        let user = result.data.getLoggedUserData
        let settingsColumns = user === null || user.listStorageSettings === null ? this.defaultSettingsColumns : user.listStorageSettings
        const columns: IColumn[] = [
            {
                key: 'displayName', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "storageDisplayName")}</>)}</MyContext.Consumer>, fieldName: 'displayName', minWidth: 100, maxWidth: 200, isResizable: true
            },
            {
                key: 'visibleForAssignment', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "visibleForAssignment")}</>)}</MyContext.Consumer>, fieldName: 'visibleForAssignment', minWidth: 150, maxWidth: 150,
                onRender(item) {

                    return <Checkbox checked={item.visibleForAssignment} disabled />
                }
            },
            {
                key: 'isActive', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "isActive")}</>)}</MyContext.Consumer>, fieldName: 'isActive', minWidth: 70, maxWidth: 70,
                onRender(item) {

                    return <Checkbox checked={item.isActive} disabled />
                }
            },
            {
                key: 'storageLocation', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "storageLocation")}</>)}</MyContext.Consumer>, fieldName: 'storageLocation', minWidth: 150, maxWidth: 150

            },
            {
                key: 'storageAccountName',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "customerStorageAccountName")}</>)}</MyContext.Consumer>,
                fieldName: 'storageAccountName',
                minWidth: 100,
                maxWidth: 200,
                onRender: (item) => {
                    if (item.storageLocation === 'S3') {
                        return item.awsBucketName;
                    } else {
                        return item.storageAccountName;
                    }
                }
            },
            {
                key: 'storageUsed',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "storageConsumption")}</>)}</MyContext.Consumer>,
                fieldName: 'storageUsed',
                minWidth: 100,
                maxWidth: 200,
                onRender: (item) => {
                    if (item.group === 'custom') {
                        return null;
                    }
                    return <span>{item.storageUsed}GB</span>;

                }
            },
            {
                key: 'keyVaultUrl', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "keyVault")}</>)}</MyContext.Consumer>, fieldName: 'keyVaultUrl', minWidth: 70, maxWidth: 70,
                onRender(item) {

                    return <Checkbox checked={item.keyVaultUrl !== null && item.keyVaultUrl !== ""} disabled />
                }
            },
            {
                key: 'isAsymmetric', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "isAsymmetric")}</>)}</MyContext.Consumer>, fieldName: 'isAsymmetric', minWidth: 110, maxWidth: 110,
                onRender(item) {

                    return <Checkbox checked={item.isAsymmetric} disabled />
                }
            },
            {
                key: 'keyVaultName', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "keyVaultName")}</>)}</MyContext.Consumer>, fieldName: 'keyVaultName', minWidth: 110, maxWidth: 200,
                onRender(item) {

                    return <strong>{item.keyVaultName}</strong>
                }

            },
            {
                key: 'archiving', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "archiving")}</>)}</MyContext.Consumer>, fieldName: 'archiving', minWidth: 70, maxWidth: 80,
                onRender(item) {
                    if (item.storageLocation === 'S3') {
                        return null;
                    }
                    if (!item.archiving || item.archiving === "Nan") {
                        return null;
                    }

                    return <Checkbox checked={item.archiving === "True"} disabled />
                }
            },

        ];
        let resultColumns = columns
        resultColumns = settingsColumns.map(c => {
            return resultColumns.filter(col => col.fieldName === c)[0]
        }).filter(d => d !== undefined)
        this.setState({
            columns: resultColumns,
            allColumns: columns,
            settingsColumns: settingsColumns
        })

    }

    render() {
        const { columns, allColumns, settingsColumns, isCompactMode, isModalSelection, columnsDefaultSetting, defaultStorageItem } = this.state;
        //sort
        var storageArray = this.props.data;

        const groupOrder = { tenant: 0, asc: 1, custom: 2 };

        const compare = (a, b) => {
            if (groupOrder[a.group] < groupOrder[b.group]) return -1;
            if (groupOrder[a.group] > groupOrder[b.group]) return 1;

            return a.displayName.localeCompare(b.displayName);
        };

        storageArray.sort(compare);

        this.storageData = this._generateDocuments(storageArray, this.state.filter);
        return (
            <Fabric>
                <ComanderBar sel={"storage"} onChangeX={this._onChangeText} stylesX={controlStyles} close={this.props.close} openNew={this.openNew} edit={this.openSelect} authorization={this.props.authorization} apol={this.props.apol} displayHistorical={this.state.displayHistorical} setDisplayHistorical={this.setDisplayHistorical} />
                <SettingsColumnsStorages settingsColumns={settingsColumns} allColumns={allColumns} updateColumnsSettings={this.updateColumnsSettings} apol={this.props.apol} />
                {/*Warning and error message*/}
                <AlertBar
                    message={this.state.warningMessage}
                    alertType={this.state.alertType}
                    clearAlert={() => { this.setState({ warningMessage: "" }) }}
                />
                <DetailsList
                    items={defaultStorageItem}
                    columns={columnsDefaultSetting}
                    selectionMode={SelectionMode.none}
                    layoutMode={DetailsListLayoutMode.justified}
                />

                <MarqueeSelection selection={this._selection}>

                    <DetailsList
                        items={[...this.storageData].sort((a, b) => { return a.isHistorical === b.isHistorical ? 0 : a.isHistorical ? 1 : -1; })}
                        compact={isCompactMode}
                        groups={this.generateGroups()}
                        columns={columns}
                        setKey="set"
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                        selection={this._selection}
                        selectionPreservedOnEmptyClick={true}
                        enterModalSelectionOnTouch={true}
                        ariaLabelForSelectionColumn="Toggle selection"
                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                        groupProps={{
                            showEmptyGroups: true
                        }}
                        selectionMode={SelectionMode.single}

                    />
                </MarqueeSelection>
            </Fabric>
        );
    }
    setDisplayHistorical() {
        this.setState((prevState) => ({ displayHistorical: !prevState.displayHistorical }));
    }

    componentDidUpdate(previousProps: any, previousState: IDetailsListDocumentsExampleState) {
        if (previousState.isModalSelection !== this.state.isModalSelection && !this.state.isModalSelection) {
            this._selection.setAllSelected(false);
        }
    }
    generateGroups = () => {
        let out = [];
        let ascStorages = 0, customStorages = 0, tenantDefaultStorage = 0, historicalStorages = 0;

        switch (this.props.data) {

            case null: return out;
            case undefined: return out;

            default:
                for (let i = 0; i < this.props.data.length; i++) {
                    switch (this.props.data[i].group) {
                        case "asc": ascStorages++; break;
                        case "custom":
                            if (this.props.data[i].isHistorical === false) {
                                customStorages++
                            } else historicalStorages++;
                            break;
                        case "tenant": tenantDefaultStorage++; break;
                        default: break;
                    }

                }
                return [
                    //commented because we have alreadu a default displayed this was extra
                    //{ key: 'groupTenantDefaultStorage', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "defaultStorage")}</>)}</MyContext.Consumer>, startIndex: 0, count: tenantDefaultStorage, isCollapsed: false },
                    { key: 'groupASCStorages', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "ASCStorages")}</>)}</MyContext.Consumer>, startIndex: tenantDefaultStorage, count: ascStorages },
                    { key: 'groupCustomStorages', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "customStorages")}</>)}</MyContext.Consumer>, startIndex: tenantDefaultStorage + ascStorages, count: customStorages },
                    this.state.displayHistorical && { key: 'groupHistoricalStorages', name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "historicalStorages")}</>)}</MyContext.Consumer>, startIndex: tenantDefaultStorage + ascStorages + customStorages, count: historicalStorages }
                ].filter(Boolean)
        }
    };

    getDefaultStorage = () => {
        let defaultStorage = [
            {
                key: '1',
                defaultStorage: "None",
            }

        ];
        if (this.props.data !== null) {
            for (let i = 0; i < this.props.data.length; i++) {
                if (this.props.data[i].group === "tenant") {
                    defaultStorage = [{
                        key: '1',
                        defaultStorage: this.props.data[i].displayName,
                    }
                    ];
                    break;
                }

            }
        }
        return defaultStorage;
    }

    _onChangeCompactMode = (ev: React.MouseEvent<HTMLElement>, checked: boolean): void => {
        this.setState({ isCompactMode: checked });
    };

    _onChangeModalSelection = (ev: React.MouseEvent<HTMLElement>, checked: boolean): void => {
        this.setState({ isModalSelection: checked });
    };

    _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
        this.storageData = this.storageData.filter(i => i.storageDisplayName.includes(text) || i.storageAccountName.toLocaleLowerCase().includes(text));
        this.setState({ filter: text });
    };


    _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return '';
            case 1:
                return 'One item selected: ' + (this._selection.getSelection()[0]).storageAccountName;
            default:
                return `${selectionCount} Items selected`;
        }
    }
    openSelect = () => {
        if (this._selection.getSelection().length > 0) {
            // add defaultStorage property to each selected item
            const selection = this._selection.getSelection().map(item => ({
                ...item,
                defaultStorage: this.state.defaultStorageItem && this.state.defaultStorageItem[0]
                    ? this.state.defaultStorageItem[0].defaultStorage
                    : null
            }));
            this.props.func(selection, 30);
        } else {
            //no element selected
            this.setState({
                warningMessage: "Select a storage",
                alertType: "warning"
            })
        };
    };

    openNew = () => {
        this.props.func(null, 30);

    };

    _generateDocuments(DataArr, text) {
        // First filter
        let DataArrFiltered = DataArr.filter(i => i.storageAccountName.includes(text) || i.storageAccountName.toLocaleLowerCase().includes(text));
        console.log("DataArrFiltered", DataArrFiltered)
        // Then sort
        let newColumns = this.state.columns;
        newColumns.forEach((newCol: IColumn) => {
            if (newCol.isSorted) {
                DataArrFiltered = this._copyAndSort(DataArrFiltered, newCol.storageAccountName, newCol.isSortedDescending);
            }
        });

        return DataArrFiltered;
    };

    _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey;
        return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
    };

    updateColumnsSettings = (columns) => {
        this.setState({ columns })
    }
}




